import * as React from "react";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { isIDFPartnerUser } from "../../util/partner";
import { ApplicationState } from "../../store";
import LegalDocumentContainer from "../LegalDocumentPages/LegalDocumentContainer";
interface IProps {
    onCloseCallback?: any;
}

const WrittenInstructionDialog: React.FunctionComponent<IProps> = (props) => {
    const { t: tLang } = useTranslation();
    const hasSontiqBrand = useSelector((state: ApplicationState) =>
        state.configurationState && state.configurationState.configuration.partnerConfig.hasSontiqBrand
            ? state.configurationState.configuration.partnerConfig.hasSontiqBrand == "true"
                ? true
                : false
            : false
    );
    const isIDFPartner = useSelector((state: ApplicationState) =>
        state.configurationState &&
            state.configurationState.configuration.partnerConfig.partnerId &&
            state.configurationState.configuration.partnerConfig.isIdfPartner
            ? !isIDFPartnerUser(state.configurationState.configuration.partnerConfig.partnerId)
            : false
    );
    let defaultTncLink: string = "https://www.sontiq.com/terms-of-use/";
    let defaultpersonalLink: string = "https://www.sontiq.com/privacy-policy/#notice-at-collection";
    const { getTermsOfUseURL, getPrivacyNoticeURL, getPrivacyNoticeLinkText, getTermsOfUseLinkText, getPersonalInfoLinkText } = LegalDocumentContainer();
    const closeDialog = () => {
        props.onCloseCallback();
    }
    return (
        <React.Fragment>
            <div className="link-style">
                <div className="dialog-header">
                    <span className="dialog-icon status-default">
                        <em className="las la-file-invoice"></em>
                    </span>
                </div>

                <div>
                    <p>
                        {tLang("registration.billing.terms-of-Use.terms-IdfText")}
                        <div className="margin-bottom-l"></div>
                        {tLang("registration.billing.terms-of-Use.terms-Text2")} {" "}
                        {(hasSontiqBrand || isIDFPartner) ? (
                            <a href={defaultTncLink} target="_blank">
                                {getTermsOfUseLinkText()}
                            </a>
                        ) : (
                            <a href={getTermsOfUseURL()} target="_blank">
                                {getTermsOfUseLinkText()}
                            </a>
                        )}
                        {", "}
                        <a href={getPrivacyNoticeURL()} target="_blank">{"Privacy Notice"}</a>  {" "}
                        {tLang("registration.billing.terms-of-Use.terms-Text3")} {" "}
                        <a href={defaultpersonalLink} target="_blank">
                            {getPersonalInfoLinkText()}
                        </a>
                        {"."}
                    </p>

                </div>

                <div className="dialog-footer">
                    <div className="row between-xs">
                        <div className="col-xs col-no-gutter flex-grow-null"></div>
                        <div className="col-xs col-no-gutter flex-grow-null">
                            <button className="btn-default btn-primary" onClick={closeDialog}>
                                <span className="btn-text">Continue</span>
                            </button>
                        </div>
                    </div>
                </div>

            </div>
        </React.Fragment>
    );
};

export default WrittenInstructionDialog;
